import { get } from 'lodash';
import _ from 'lodash';

export const name = company => get(company, 'companyName');
export const companyContact = company => get(company, 'contact[0].name');
export const companyContactPhone = company => get(company, 'contacts[0].phone', null);

export const companyNightPhone = company => get(company, 'contacts[0].nightPhone');
export const companyNightContact = company => get(company, 'contact[0].nightContactName');

export const locationDaytimePhone = loadLocation => get(loadLocation, 'daytimePhone', null);
export const locationNightTimePhone = loadLocation => get(loadLocation, 'nightTimePhone', null);

export const hasLoadingChutes = company => company.loadingInfo &&
  company.loadingInfo.loadingLocations;

export const loadingChutes = (company) => {
  const loadLocations = get(company, 'loadingInfo.loadingLocations', []);
  return loadLocations.map((ll) => {
    return {
      label: get(ll, 'chute.label'),
      googlePlaceId: get(ll, 'googlePlace.placeId'),
      googlePlaceName: get(ll, 'googlePlace.placeName'),
      formattedAddress: get(ll, 'googlePlace.formattedAddress'),
      daytimePhone: get(ll, 'chute.daytimePhone'),
      nightTimePhone: get(ll, 'chute.nightTimePhone'),
      instructions: get(ll, 'chute.instructions'),
    };
  });
};

export const isTruckingCompany = company => !!get(company, 'truckingInfo.dotNumber', false);
export const hasProducerInfo = company => !!get(company, 'producerInfo', false);
export const hasCDNMembers = company => !!get(company, 'carrierDispatchNetwork.members', false);
export const driversWithCDN = (company) => {
  // TODO: Need to check expiration date.
  return _.chain(company)
    .get('employees', [])
    .filter(e => get(e.driverProfile, 'cdlExpires', false))
    .map(driver => ({ ...driver, name: driver.userName || driver.contactEmail, id: driver.userId }))
    .sortBy(['name', 'id'], ['asc', 'asc'])
    .value();
};

export default {
  name,
  companyContact,
  companyContactPhone,
  companyNightContact,
  companyNightPhone,

  hasLoadingChutes,
  loadingChutes,
  locationDaytimePhone,
  locationNightTimePhone,
  isTruckingCompany,
  hasProducerInfo,
  hasCDNMembers,
  driversWithCDN,
};



// WEBPACK FOOTER //
// ./src/types/models/company.js